import React from 'react';
import nl2br from './nl2br';

export const URL_REGEX = /((http|ftp|https):\/\/w{3}[\d]*\.|(http|ftp|https):\/\/|w{3}[\d]*\.)([\w\d\._\-#\(\)\[\]\\,;:]+@[\w\d\._\-#\(\)\[\]\\,;:])?([a-z0-9가-힣]+\.)*[a-z가-힣\-0-9]+\.([a-z]{2,3})?[a-z]{2,6}(:[0-9]+)?(\/[\/a-z0-9가-힣\._\-,]+)*[a-z0-9가-힣\-_\.%]+(\?[a-z0-9가-힣=%&amp;\.\-,#]+)?|[a-z0-9]+:\/\/\S+/gim;

export function hasUrlString(str) {
  if (!str) return false;

  const result = str.match(URL_REGEX);
  return !!(result && (result.length > 0));
}

export function getUrlString(str) {
  if (!str) return false;
  const result = str.match(URL_REGEX);
  return !result ? [] : result;
}

export function linkify(contents) {
  return contents.map((e, idx) => {
    const t = e.get('t');
    const v = e.get('v');
    if (t === 'link') {
      const url = (v.startsWith('http://') || v.startsWith('https://')) ? v : `http://${v}`;
      return (
        <a href={url}
          target="_blank" className="link_url" key={idx}
        >
          {nl2br(e.get('v'))}
        </a>
      );
    }
    return (<span key={idx}>{nl2br(v)}</span>);
  });
}

const LANG_QUERY_PARAM_REGEX = /^(ko|en|ja)$/i;
export function getLangQuery(request) {
  const {query} = request;
  const lang = (query && query.lang) ? query.lang : null;

  const result = lang && lang.match(LANG_QUERY_PARAM_REGEX);
  if (result) {
    return lang;
  } else {
    return null;
  }
}

export function isValidKakaoDomain(url) {
  let pfHomeHost = global.REACT_APP_SERVICE_HOST;
  if(!global.REACT_APP_SERVICE_HOST.endsWith('/')){
    pfHomeHost = pfHomeHost + '/';
  }

  let syncHomeHost = global.REACT_APP_MEMBERSHIP_HOST;
  if(!global.REACT_APP_MEMBERSHIP_HOST.endsWith('/')){
    syncHomeHost = syncHomeHost + '/';
  }

  if (url.includes('https://sandbox-pf.kakao.com/') || url.includes(pfHomeHost) || url.includes(syncHomeHost)) {
    return true;
  }

  return false;
}

export function isValidProfileIdParam(param) {
  const patterns = [
    /^_[a-zA-Z]+$/,
    /^@[0-9a-z가-힣\-_]+$/,
    /^[1-9]+[0-9]*$/
  ];
  return patterns.some(regex => regex.test(param));
}


// WEBPACK FOOTER //
// ./src/utils/urlUtil.js